import { Radio } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/ChameleonElement';
export class RadioButtonComponent extends ChameleonElementMixin(Radio) {
    connectedCallback() {
        var _a;
        super.connectedCallback();
        const control = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.control');
        control === null || control === void 0 ? void 0 : control.setAttribute('tabindex', '0');
    }
}
